"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_DOMAIN_HEADER = exports.gql = exports.getClient = void 0;
const graphql_request_1 = require("graphql-request");
const graphql_tag_1 = require("graphql-tag");
Object.defineProperty(exports, "gql", { enumerable: true, get: function () { return graphql_tag_1.gql; } });
const config_1 = require("./config");
const js_cookie_1 = __importDefault(require("js-cookie"));
let $client;
exports.COOKIE_DOMAIN_HEADER = 'x-oneauth-cookie-domain';
function initClient() {
    const url = config_1.getAuthGateUrl();
    $client = new graphql_request_1.GraphQLClient(url, {
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
        },
    });
    if (js_cookie_1.default.get('_px3')) {
        $client.setHeader('x-px-chegg-cookie', js_cookie_1.default.get('_px3'));
    }
    if (config_1.isAltAuthgateUrl()) {
        $client.setHeader(exports.COOKIE_DOMAIN_HEADER, config_1.getCookieDomain());
    }
}
function getClient() {
    if (!$client) {
        initClient();
    }
    return $client;
}
exports.getClient = getClient;
